export default __webpack_public_path__ + "static/media/checked.02561bc0.svg";